export default __webpack_public_path__ + "static/media/1219.cbf2cd40.png";